<template>
  <div class="videopage bg" :class="{'bgruleHei':show_menu==1}">
      <v-nav @showDownMenu="showDownMenu"></v-nav>
      <mode class="modeapp" v-if="loadMode"></mode>
      <div class="video_main">
        <div class="search">
          <input type="text" placeholder="输入关键字搜索" @input="putSearch" v-model="title">
          <div class="searchbtn" @click="searchVideo">搜索</div>
        </div>
        <div class="video" id="videobox" >
          <video  :class="{'videohide':controlImg}"  id="videoplay" ref="video_play"   x5-playsinline="true" playsinline="true" webkit-playsinline="" x-webkit-airplay="true" x5-video-player-type="h5" x5-video-player-fullscreen='false' x5-video-orientation="portraint" src="" controls >

          </video>
          <!--<canvas style="width:100px;height: 100px;object-fit: cover"></canvas>-->
          <img style="width:100%;height: 4.25rem;object-fit: cover" :src="img?img:require('../../assets/images/phone/videoimg.png')"  class="ctrlimg" v-if="show_menu==1||veidoRes==1||veidoRes==2"/>
          <!--<canvas id="mycanvas"></canvas>--
          <!--<div class="isplay" v-if="isPlay" @click="playVideo" >-->
            <!--<div class="img">-->
              <!--<img src="../../assets/images/stop.png" alt="播放">-->
            <!--</div>-->
          <!--</div>-->
        </div>
        <div class="video-ctrl">
          <div class="video-title textover">{{videoName}}</div>
          <div class="option_group" v-if="qqsystem">
            <div class="down" @click="downVideo">
              <div class="txt">下载</div>
            </div>
          </div>
        </div>
        <div class="all_video">
          <div class="all_video_box">
            <div class="about_video">
              <div class="img">
                <img src="../../assets/images/phone/icondown.png" alt="相关剧集" title="相关剧集">
              </div>
              <div class="about_txt">相关剧集</div>
            </div>
            <div class="video_group">
              <div class="video_list"  @click.stop="selectVideo(item,index)" :class="{'listdown':item.down==true}" v-for="(item,index) in videoList">
                <div class="video_list_content">
                  <div class="video_title textover">{{item.className}}</div>
                  <div class="video_icon">
                    <img src="../../assets/images/phone/iconright.png" alt="打开">
                  </div>
                </div>
                <div class="vidwo_list_item" :id="'a'+items.id"  @click.stop="selectVideoPlay(item,index,items,indexs)" v-for="(items,indexs) in item.list">
                  <div class="item_title textover">{{items.title}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <transition name="fade">
        <!--没有搜索到视频-->
        <div class="no_search_video" v-if="veidoRes==1">
          <div class="video_con">
            <div class="video_con_main">
              <div class="txt">没有搜索到关键词视频</div>
              <div class="img" @click="closeSearch">
                <img src="../../assets/images/close.png" alt="关闭">
              </div>
            </div>
          </div>
        </div>
      </transition>
        <!--搜索到视频-->
      <transition name="fade">
          <div class="no_search_video" v-show="veidoRes==2">
            <div class="video_resbox">
              <div class="has_video" ref="videolist">
                <div class="video_con_main">
                  <div class="img" @click="closeSearch">
                    <img src="../../assets/images/close.png" alt="关闭">
                  </div>
                  <div class="listitem" @click="selectSearch(item,index)" v-for="(item,index) in searchVideoList">
                    <a :href="'#a'+item.classId">
                      <div class="filename item textover">
                        {{item.classTitle}}
                      </div>
                      <div class="search-opt">
                        时长：{{item.start}}-{{item.end}}
                      </div>
                      <div class="searchcon textover">
                        {{item.keyword}}
                      </div>
                    </a>
                  </div>
                  <div class="txtcon">{{txtcon}}</div>
                </div>
              </div>
            </div>
          </div>
      </transition>
  </div>
</template>

<script>
    import mode from '@/components/bg/mode'
    import MescrollVue from 'mescroll.js/mescroll.vue'
    export default {
        name: "appvideo",
        components:{
          mode,MescrollVue
        },
        data() {
            return {
              show_menu:0,
              select:0,
              down:false,
              videoRes:0,
              isPlay:true,
              chaptid:0,
              fileid:0,
              veidoRes:0,
              videoList:[],
              loadMode:true,
              videoName:'',
              videoUrl:'',
              title:'',
              msgContent:'',
              searchVideoList:[],
              coverUrl:'',
              videoImg:'',
              controlImg:false,
              allPage:1,
              currentPage:1,
              txtcon:'上拉加载更多',
              qqsystem:false,
              img:''
            }
        },
        beforeRouteLeave(to,from,next){
          console.log(111)
          next()
          this.$nextTick(()=>{
            this.controlImg=false
          })
        },
        mounted() {
          let _this=this;
          console.log(document.getElementById("videoplay"))
          this.$refs.video_play.addEventListener('pause', function (e) {
            console.log('aaaa')
            _this.isPlay=true
          })
          this.$refs.video_play.addEventListener('play', function (e) {
            console.log('aaaa')
            _this.isPlay=false
          })
          this.$nextTick(()=>{
            var ua = navigator.userAgent.toLowerCase();
            if(ua.match(/MicroMessenger/i)=="micromessenger") {
              this.qqsystem=true
            }
          })
          this.getList()

        },
        methods: {
          showDownMenu(data){
            if(data==0){
              this.show_menu=0
              console.log(111)
              this.controlImg=false
            }else{
              console.log(222)
              this.controlImg=true
              this.show_menu=1
              this.isPlay=true;
              this.$refs.video_play.pause()
            }
          },
          //截取视频第一帧作为播放前默认图片
          findvideocover() {
            const  video = document.getElementById("videoplay"); // 获取视频对象
            // const video = document.createElement("video") // 也可以自己创建video
            video.src=this.videoUrl // url地址 url跟 视频流是一样的
            console.log(video)

            var canvas = document.createElement('canvas') // 获取 canvas 对象
            const ctx = canvas.getContext('2d'); // 绘制2d
            // video.crossOrigin = 'anonymous' // 解决跨域问题，也就是提示污染资源无法转换视频
            video.currentTime = 1 // 第一帧
            video.oncanplay = (res) => {
              console.log(res)
              canvas.width = video.clientWidth// 获取视频宽度
              canvas.height = video.clientHeight//获取视频高度
              // 利用canvas对象方法绘图
              // canvas.setAttribute('crossOrigin','anonymous')
              ctx.drawImage(video, 0, 0, video.clientWidth,video.clientHeight)
              var img=new Image()
              img.crossOrigin='Anonymous'
              // img.src=canvas.toDataURL ("image/png").replace("image/png","image/octet-stream")
              // 转换成base64形式
              // this.videoImg = canvas.toDataURL ("image/png") // 截取后的视频封面
             // console.log(this.videoImg)

            }
          },
          playVideo(){
            console.log(111)
            if(this.$refs.video_play.paused){
              this.$refs.video_play.play()
              this.isPlay=false
              console.log(222)
            }else{
              console.log(333)
              this.isPlay=true
              this.$refs.video_play.pause()
            }
          },
          selectVideo(item,index){
            if(this.videoList[index].down==0){
              this.videoList[index].down=1
            }else{
              this.videoList[index].down=0
            }

          },
          selectVideoPlay(item,index,items,indexs){
            this.chaptid=item.id
            this.fileid=items.id
            this.$refs.video_play.src=items.save_url
            this.videoUrl=items.save_url
            this.videoName=item.className+'-'+items.title
            this.img=item.image
            let videoInfo={classid:item.id,fileid:items.id,videourl:items.save_url,index:index,videoname:item.className+'-'+items.title,image:this.img}
            window.localStorage['video']=JSON.stringify(videoInfo)
          },
          putSearch(){
            this.currentPage=1
          },
          searchVideo(){
            this.loadMode=true
            this.txtcon='正在加载……'
            this.$http({
              url: '/Video/find',
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              data: {title:this.title,page:this.currentPage}
            }).then((res) => {
              console.log(res)
              this.loadMode=false
              if(res.data.code==0){
                this.veidoRes=2
                res.data.data.data.map((item,index,arr)=>{
                  item.filename=item.classTitle.split(' ')[0]
                  item.videoTitle=item.classTitle.split(' ')[1]||item.classTitle.split('  ')[1]
                  return item
                })
                this.controlImg=true
                this.$refs.video_play.pause()
                if(this.currentPage==1){
                  this.searchVideoList=res.data.data.data
                }else{
                  this.searchVideoList=this.searchVideoList.concat(res.data.data.data)
                }

                this.videoListScroll(res.data.data.info.page_sum)
              }else{
                console.log('222')
                this.veidoRes=1
                this.msgContent=res.data.msg
              }
            })
            .catch((error) => {
              // error
              this.$layer.msg('网络错误')
              console.log(error)
            })
          },
          videoListScroll(pagesum){
            this.$refs.videolist.onscroll=(e)=>{
              let scrollTop=this.$refs.videolist.scrollTop
              let windowHeight=this.$refs.videolist.clientHeight
              let scrollHeight=this.$refs.videolist.scrollHeight
              if((scrollTop+windowHeight>=scrollHeight)&&(this.currentPage<=this.allPage)){
                console.log('滚到底部')
                this.currentPage++
                this.allPage=pagesum

                this.searchVideo()
              }else{
                this.txtcon='没有更多数据了'
              }
            }
          },
          closeSearch(){
            this.veidoRes=0
            this.controlImg=false
          },
          selectSearch(items,index){
            console.log(items)
            console.log(index)
            console.log(111)
            this.chaptid=items.file_id[0].category_id
            let indexs
            let itemArr=[]
            let findItemArr=[]
            this.videoList.map((item,index,arr)=>{
              item.down=0
              if(item.id==items.file_id[0].category_id){
                console.log(item)
                indexs=index
                console.log(indexs)
                return itemArr=item
              }
            })
            console.log(findItemArr)
            this.videoList[indexs].down=1
            console.log(itemArr)
            console.log(itemArr.list[0])
            this.fileid=items.classId
            this.$refs.video_play.src=items.file_id[0].save_url
            this.$refs.video_play.currentTime=items.start_seconds
            this.videoUrl=items.file_id[0].save_url
            this.videoName=items.classTitle
            let videoInfo={classid:items.id,fileid:this.fileid,videourl:this.videoUrl,index:indexs,videoname:this.videoName}
            window.localStorage['video']=JSON.stringify(videoInfo)
            this.veidoRes=0
            this.controlImg=false
          },
          getList(){
            this.$http({
              url: '/Video/search',
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              data: {title:this.title}
            }).then((res) => {
              console.log(res)
              this.loadMode=false
              if(res.data.code==0){
                this.videoList=res.data.data.map((item,index,arr)=>{
                  item.down=false
                  return item
                })
                this.loadMode=false
                if(window.localStorage['video']){
                  let videoInfo=JSON.parse(window.localStorage['video'])
                  this.videoList[videoInfo.index].down=true
                  this.chaptid=videoInfo.classid
                  this.fileid=videoInfo.fileid
                  this.videoName=videoInfo.videoname
                  this.videoUrl=videoInfo.videourl
                  this.img=videoInfo.image
                  this.$nextTick(()=>{
                    this.$refs.video_play.src=videoInfo.videourl
                  })
                }else{
                  this.videoList[0].down=true
                  this.chaptid=this.videoList[0].id
                  this.fileid=this.videoList[0].list[0].id
                  this.videoName=this.videoList[0].className+'-'+this.videoList[0].list[0].title
                  this.videoUrl=this.videoList[0].list[0].save_url
                  this.img=this.videoList[0].image
                  this.$nextTick(()=>{
                    this.$refs.video_play.src=this.videoList[0].list[0].save_url
                  })
                }
                console.log(this.$refs.video_play.offsetHeight)
                this.$nextTick(()=>{
                  this.findvideocover()
                })
              }else{
                console.log('222')
                this.veidoRes=1
                this.msgContent=res.data.msg
              }
            })
              .catch((error) => {
                // error
                this.$layer.msg('网络错误，请稍后重试')
                console.log(error)
              })
          },
          async downVideo(){
            this.$layer.msg("请在其它浏览器中打开",{icon:1});
            return
            this.$layer.msg("正在下载,请稍后",{icon:1});//提示框
            let response = await fetch(this.videoUrl); // 内容转变成blob地址
            console.log(response)
            let blob = await response.blob();  // 创建隐藏的可下载链接
            let objectUrl = window.URL.createObjectURL(blob);
            let a = document.createElement('a');
            a.href = objectUrl;
            a.target='_new'
            a.download = this.videoName;
            a.click()
            a.remove();
            this.$layer.msg("文件下载成功",{icon:1});
          },
        }
    }
</script>

<style scoped lang="scss">
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .mescroll {
    position: fixed;
    top: 44px;
    bottom: 0;
    height: auto;
  }
  .listitem:first-child{
    border-bottom:none;
  }
  .listitem:hover{
    color:#c9a168;
  }
  .listitem{
    padding:0.3rem 0.2rem;
    border-bottom:1px dashed #ebebeb;
    box-sizing: border-box;
    a{
      display: block;
    }
    .item{
      text-align: center;
      color:#333;
      font-size:0.28rem;
      cursor: pointer;
    }
    .filename{
      width:100%;
      text-align: left;
      font-size:0.28rem;
      color:#614513;
      font-weight: bold;
      line-height: 0.4rem;
    }
    .search-opt{
      font-size:0.24rem;
      line-height: 0.3rem;
      color:#999;
      padding:0.2rem 0;
    }
    .searchcon{
      font-size:0.24rem;
      line-height: 0.3rem;
      color:#999;
    }
    .options{
      width:25%;
    }
    .videolong{
      width:35%;
    }
  }
  .bg{
    background: url("../../assets/images/phone/bg.jpg")no-repeat left bottom;
    position: fixed;
    top:0;
    min-height: 100%;
    left:0;
    right:0;
    bottom:0;
    overflow: hidden;
    background-size:100% 100%;
  }
  .videopage{
   .video_main{
     padding:0.28rem 0.28rem 0;
     height:calc(100% - 1rem);
     box-sizing: border-box;
     .search{
       width:100%;
       height:0.8rem;
       border:1px solid #c9a168;
       box-sizing: border-box;
       border-radius:6px;
      background: #fff;
       display: flex;
       align-items: center;
       justify-content: space-between;
       padding:0 0.2rem 0 0;
       input{
         width:calc(100% - 1.5rem);
         border:none;
         height:100%;
         border-radius:6px;
         padding-left:0.95rem;
         box-sizing: border-box;
         background: url("../../assets/images/phone/search.png")no-repeat #fff 0.3rem center;
         background-size:0.38rem auto;
         font-size:0.28rem;
       }
       .searchbtn{
         width:1.28rem;
         height:0.6rem;
         background: #c9a168;
         border-radius:4px;
         color:#fff;
         font-size:0.28rem;
         text-align: center;
         line-height: 0.6rem;
       }
     }
     .video{
       margin-top:0.6rem;
       width:100%;
       height:4.25rem;
       position: relative;
       .videohide{
         opacity: 0 !important;
         height:0 !important;
         width:0 !important;
       }
       video{
         width:100%;
         height:4.25rem;
         object-fit: fill;
         display: block;
         overflow: hidden;
         opacity: 1;
       }
       .ctrlimg{
         position: absolute;
         object-fit: contain;
         top:0;
         left:0;

         /*<!--top:50%;-->*/
         /*<!--margin-top:-2.12rem;-->*/
         /*<!--left:50%;-->*/
         /*<!--margin-left:calc(-50% + 0.28rem);-->*/
         /*<!--margin-left:-50%;-->*/
         /*<!--display: block;-->*/
         /*<!--width:100%;-->*/
         /*<!--height:4.25rem;-->*/
       }
       .ctrlimgbox{
         width:100%;
         height:4.25rem;
         overflow: hidden;
         position: absolute;
         top:0;
         left:0;


       }

       .isplay{
         position: absolute;
         top:0;
         left:0;
         bottom:0;
         width:100%;
         background:rgba(0,0,0,0.2);
         .img{
           width:100%;
           height:100%;
           cursor: pointer;
           img{
             position: absolute;
             top:0;
             bottom:0;
             left:0;
             right:0;
             margin:auto;
             width:0.8rem;
             height:0.8rem;
           }
         }
       }
     }
     .video-ctrl{
       display: flex;
       background: #443f37;
       height:0.88rem;
       align-items: center;
       padding:0 0.2rem;
       box-sizing: border-box;
       justify-content: space-between;
       position: relative;
       /*z-index:999;*/
       .video-title{
         /*width:55%;*/
         font-size:0.28rem;
         color:#fefefe;
       }
       .option_group{
         display: flex;
         /*width:45%;*/
         justify-content: space-between;
         align-items: center;
         .option{
           width:0.88rem;
           height:0.52rem;
           border-radius:3px;
           text-align: center;
           line-height: 0.52rem;
           border:1px solid #fff;
           color:#fff;
           font-size:0.26rem;
         }
         .option:first-child{
           margin-right:0.2rem;
         }
         .down{
           display: flex;
           flex-direction: column;
           justify-content: center;
           align-items: center;
           padding:0 0 0 0.3rem;
           .img{
             img{
               width:0.36rem;
               height:0.36rem;
               display: flex;
             }
           }
           .txt{
             font-size:0.26rem;
             color:#eec790;
             border:1px solid #eec790;
             border-radius:2px;
             padding:0 0.1rem;
           }
         }
       }
     }
     .all_video{
       width:100%;
       height:calc(100% - 7rem);
       .all_video_box{
          background: #544d43;
          height:100%;
          overflow: hidden;
         .about_video{
           display: flex;
           align-items: center;
           padding:0 0.2rem;
           box-sizing: border-box;
           background: #544d43;
           box-shadow: 0px -1px 1px #6e6354 inset;
           height:0.8rem;
           .img{
             img{
               width:0.27rem;
               height:0.2rem;
               display: block;
             }
           }
           .about_txt{
             color:#ffffff;
             font-size:0.3rem;
             padding-left:0.2rem;
           }
         }
         .video_group{
           height:calc(100% - 0.8rem);
           overflow-y: auto;
           .video_list{
             max-height:0.8rem;
             transition: max-height 0.5s;
             overflow: hidden;
             box-shadow: 0px -1px 1px #6e6354 inset;
             .video_list_content{
               padding:0 0.28rem 0 0.9rem;
               height:0.8rem;
               display: flex;
               justify-content: space-between;
               align-items: center;
               box-sizing: border-box;
             }
             .video_title{
               width:90%;
               color:#fff;
               font-size:0.26rem;
             }
             .video_icon{
               transition: transform 0.5s;
               img{
                 width:0.15rem;
                 height:0.29rem;
                 display: block;
               }
             }
             .vidwo_list_item{
               box-sizing: border-box;
               box-shadow: 0px -1px 1px #6e6354 inset;
               height:0.8rem;
               background: #c9a168;
               padding:0 0.5rem 0 1.1rem;
               .item_title{
                 height:0.8rem;
                 line-height: 0.8rem;
                 color:#fff;

                 font-size:0.26rem;
               }
             }
             .vidwo_list_item:last-child{
               box-shadow: none;
             }
           }
           .listdown{
              max-height:100rem;
              .video_icon{
                transform:rotate(90deg);
              }
           }
         }
       }

     }
   }
   .no_search_video{
     position: fixed;
     top:0;
     bottom:0;
     left:0;
     right:0;
     background:rgba(0,0,0,0.2);
     .video_con{
       width:6rem;
       height:3rem;
       background: #fff;
       border-radius:6px;
       position: absolute;
       top:0;
       bottom:0;
       left:0;
       right:0;
       margin:auto;
       .video_con_main{
         width:100%;
         height:100%;
         position: relative;

         .txt{
           text-align: center;
           line-height: 3rem;
           font-size:0.32rem;
           color:#614513;
         }
         .img{
           width:0.47rem;
           height:0.47rem;
           position: absolute;
           top:0;
           right:0;
           padding:0.15rem;
           img{
             width:0.47rem;
             height:0.47rem;
             display: block;
           }
         }
       }

     }
     .video_resbox{
       width:100%;
       padding:0 0.28rem;
       box-sizing: border-box;
       position: absolute;
       display: flex;
       align-items: center;
       height:100%;
       .has_video{
         height:80%;
         width:100%;
         background: #fff;
         border-radius:6px;
         overflow-y: auto;
         .video_con_main{
           width:100%;
           height:100%;
           padding:0 0.2rem;
           box-sizing: border-box;
           position: relative;
           .txtcon{
             text-align: center;
             padding:0.3rem 0;
             color:#999;
           }
           .img{
             width:0.47rem;
             height:0.47rem;
             position: absolute;
             top:0;
             right:0;
             padding:0.15rem;
             img{
               width:0.47rem;
               height:0.47rem;
               display: block;
             }
           }
           ul{
             padding:0.66rem 0.2rem;
             box-sizing: border-box;
             width:100%;
             li{
               border-bottom:1px dashed #ebebeb;
               padding:0.2rem 0;
               .videotitle{
                 width:100%;
                 color:#333;
                 font-size:0.28rem;
               }
               .videomsgbox{
                 display: flex;
                 .msgitem{
                   display: flex;
                   .opt{
                     font-size:0.24rem;
                     color:#614513;
                     padding:0 0.35rem 0 0.2rem;
                   }
                   .val{
                     font-size:0.24rem;
                     color:#333333;
                   }
                 }
                 .msgitem:first-child{
                   margin-right:1.17rem;
                 }
               }
             }
           }
         }
       }
     }

   }
  }
</style>



// WEBPACK FOOTER //
// src/views/m/video.vue